import React, { useContext } from "react";
import { Mail, Paperclip, Phone } from "react-feather";
import Chip from "../../components/Chip/Chip";
import GlobalContext from "../../context/GlobalContext";

const Application = ({
	_id,
	name,
	rollNo,
	phone,
	resume,
	purpose,
	reviewed,
	approved,
}) => {
	const { updateApplication, deleteApplication } = useContext(GlobalContext);
	const approveApplication = () => {
		updateApplication(_id, { approved: true, reviewed: true });
	};
	const declineApplication = () => {
		updateApplication(_id, { approved: false, reviewed: true });
	};
	return (
		<div
			className="application-card"
			style={{
				backgroundColor: `var(--${
					reviewed ? (approved ? "green" : "red") : "indigo"
				}-100)`,
			}}
		>
			<div className="application-card-header">
				<div className="application-card-header-left">
					<h1>{name}</h1>
				</div>
				<div className="application-card-header-right">
					<a
						href={resume}
						target="_blank"
						rel="noreferrer"
						className="resume"
						title="Resume"
					>
						<Paperclip />
					</a>
					<a
						href={`mailto:${rollNo}@iiitu.ac.in`}
						target="_blank"
						rel="noreferrer"
						className="mail"
						title={`Email: ${rollNo}@iiitu.ac.in`}
					>
						<Mail />
					</a>
					<a
						href={`tel:${phone}`}
						target="_blank"
						rel="noreferrer"
						className="phone"
						title={`Phone: ${phone}`}
					>
						<Phone />
					</a>
				</div>
			</div>
			<div
				className="application-card-body"
				style={{
					textAlign: "left",
					justifyContent: "flex-start",
				}}
			>
				Roll No. : {rollNo}
			</div>
			<div className="application-card-body">{purpose}</div>
			<div className="application-card-actions">
				<Chip
					text={reviewed && approved ? "Approved" : "Approve"}
					color="green"
					icon="check"
					size="small"
					style={{
						backgroundColor: `var(--green-${
							reviewed && approved ? 700 : 100
						})`,
						color:
							reviewed && approved
								? "var(--white)"
								: `var(--green-700)`,
						border: `2px solid var(--transparent)`,
					}}
					onClick={approveApplication}
				/>
				<Chip
					text={reviewed && !approved ? "Declined" : "Decline"}
					color="red"
					icon="close"
					size="small"
					style={{
						backgroundColor: `var(--red-${
							reviewed && !approved ? 700 : 100
						})`,
						color:
							reviewed && !approved
								? "var(--white)"
								: `var(--red-700)`,
						border: `2px solid var(--transparent)`,
					}}
					onClick={declineApplication}
				/>
				<Chip
					text="Delete"
					color="red"
					icon="delete"
					size="small"
					style={{
						backgroundColor: `var(--red-700)`,
						color: "var(--white)",
						border: `2px solid var(--transparent)`,
					}}
					onClick={() => deleteApplication(_id)}
				/>
			</div>
		</div>
	);
};

export default Application;
